import React, { useEffect, useRef } from "react";
import styled from "styled-components";

import colors from "src/assets/styles/colors.js";
import typographySizes from "src/assets/styles/typographySizes.js";
import mediaQuery from "src/assets/styles/mediaQuery.js";

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10001;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 15rem;
  padding: 20rem 20rem;
  background: linear-gradient(
    90deg,
    #f4dca0 0%,
    #f6a85c 55%,
    ${colors.orange} 100%
  );
  @media (max-width: ${mediaQuery.tablet}) {
    gap: 10rem;
    padding: 16rem 15rem;
  }
`;

const Pill = styled.span`
  flex-shrink: 0;
  font-size: ${typographySizes.xs}rem;
  letter-spacing: 1rem;
  color: ${colors.greenDark};
  background: rgba(14, 36, 38, 0.12);
  padding: 4rem 10rem;
  border-radius: 100rem;
  text-transform: uppercase;
  font-weight: 600;
`;

const Title = styled.p`
  flex-shrink: 0;
  font-size: ${typographySizes.s}rem;
  color: ${colors.greenDark};
font-weight: 600;
`;

const Divider = styled.span`
  width: 1rem;
  height: 16rem;
  flex-shrink: 0;
  background: rgba(14, 36, 38, 0.25);
  @media (max-width: ${mediaQuery.tablet}) {
    display: none;
  }
`;

const Description = styled.p`
  font-size: ${typographySizes.xs}rem;
  color: rgba(14, 36, 38, 0.8);
  @media (max-width: ${mediaQuery.tablet}) {
    display: none;
  }
`;

const Close = styled.button`
  margin-left: auto;
  flex-shrink: 0;
  cursor: pointer;
  font-size: ${typographySizes.sm}rem;
  line-height: 1;
  color: ${colors.greenDark};
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.6;
  }
`;

const Banner = ({ lang, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const setVar = () =>
      document.documentElement.style.setProperty(
        "--banner-h",
        `${el.offsetHeight}px`,
      );

    setVar();

    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver(setVar);
      resizeObserver.observe(el);
    }
    window.addEventListener("resize", setVar);

    return () => {
      document.documentElement.style.setProperty("--banner-h", "0px");
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener("resize", setVar);
    };
  }, []);

  const isEn = lang === "en";

  return (
    <Wrapper ref={ref}>
      <Pill>Soon</Pill>
      <Title>
        {isEn ? "Something new is on the way." : "Już wkrótce coś nowego."}
      </Title>
      <Divider />
      <Description>
        {isEn
          ? "Soon, this page takes a bold step forward — independent, agile and international, as ever."
          : "Wkrótce ta strona zrobi śmiały krok naprzód — niezależna, zwinna i międzynarodowa, jak zawsze."}
      </Description>
      <Close onClick={onClose} aria-label={isEn ? "Close" : "Zamknij"}>
        ×
      </Close>
    </Wrapper>
  );
};

export default Banner;
